/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {FullStorySettings} from '../models/FullStorySettings';
import type {UpdateSettingsRequest} from '../models/UpdateSettingsRequest';

export interface GetFullStorySettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getFullStorySettingsRequest = createAction<PayloadData<void>>('FULL_STORY_SETTINGS__GET_FULL_STORY_SETTINGS__REQUEST');
export const getFullStorySettingsSuccess = createAction<PayloadData<FullStorySettings>>('FULL_STORY_SETTINGS__GET_FULL_STORY_SETTINGS__SUCCESS');
export const getFullStorySettingsFailure = createAction<PayloadData<Error, void, true>>('FULL_STORY_SETTINGS__GET_FULL_STORY_SETTINGS__FAILURE');

export const getFullStorySettingsActions = [
    getFullStorySettingsRequest,
    getFullStorySettingsSuccess,
    getFullStorySettingsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getFullStorySettings = (config?: GetFullStorySettings$Config) => {
    return {
        CALL_API: {
            types: getFullStorySettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/full-story/settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface SaveFullStorySettings$Request {
    updateSettingsRequest: UpdateSettingsRequest;
}

export interface SaveFullStorySettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveFullStorySettingsRequest = createAction<PayloadData<void, SaveFullStorySettings$Request>>('FULL_STORY_SETTINGS__SAVE_FULL_STORY_SETTINGS__REQUEST');
export const saveFullStorySettingsSuccess = createAction<PayloadData<void, SaveFullStorySettings$Request>>('FULL_STORY_SETTINGS__SAVE_FULL_STORY_SETTINGS__SUCCESS');
export const saveFullStorySettingsFailure = createAction<PayloadData<Error, SaveFullStorySettings$Request, true>>('FULL_STORY_SETTINGS__SAVE_FULL_STORY_SETTINGS__FAILURE');

export const saveFullStorySettingsActions = [
    saveFullStorySettingsRequest,
    saveFullStorySettingsSuccess,
    saveFullStorySettingsFailure
] as const;

/**
 * @param {UpdateSettingsRequest} meta.updateSettingsRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveFullStorySettings = (meta: SaveFullStorySettings$Request, config?: SaveFullStorySettings$Config) => {
    return {
        CALL_API: {
            types: saveFullStorySettingsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/full-story/settings`,
            TRANSPORT_REQUEST_BODY: meta.updateSettingsRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

